import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { ApiKeyList } from "../../api/schemas/integrations";

export const CopyTarget = S.Literals(["key"]);
export type CopyTarget = typeof CopyTarget.Type;

export const Model = S.Struct({
	page: S.Literal("Integrations"),
	copied: S.Option(CopyTarget),
	keys: apiData(ApiKeyList).schema,
	keyDescription: S.String,
	creating: S.Boolean,
	revealedKey: S.Option(S.String),
});
export type Model = typeof Model.Type;
